import React, { useEffect, useState } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";

export default function AdminMembers() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isSupabaseConfigured || !supabase) {
      setLoading(false);
      return;
    }

    (async () => {
      setLoading(true);
      const { data, error: err } = await supabase
        .from("profiles")
        .select("id, email, full_name, is_admin, created_at")
        .order("created_at", { ascending: false });
      if (err) setError(err.message);
      else setRows(data || []);
      setLoading(false);
    })();
  }, []);

  if (!isSupabaseConfigured) {
    return (
      <p className="text-danger">Supabase is not configured. Add keys to .env</p>
    );
  }

  return (
    <div>
      <h1 className="h3 mb-4">Members</h1>
      <p className="text-muted small">
        Users who registered via Supabase Auth. Grant admin in the SQL editor
        with <code>is_admin = true</code> (do not expose that flag in a public
        form).
      </p>

      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <div className="table-responsive bg-white rounded shadow-sm">
          <table className="table table-sm table-striped align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Admin</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.email}</td>
                  <td>{r.full_name || "—"}</td>
                  <td>{r.is_admin ? "Yes" : "—"}</td>
                  <td>
                    {r.created_at
                      ? new Date(r.created_at).toLocaleString()
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
